import { render, staticRenderFns } from "./notification-comment.vue?vue&type=template&id=411f5963&scoped=true"
import script from "./notification-comment.vue?vue&type=script&lang=js"
export * from "./notification-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411f5963",
  null
  
)

export default component.exports